module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_1"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ABetterFreedom"
    }
  }, [_vm._v("A Better Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Introduction"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/PartOne"
    }
  }, [_vm._v("Part One: Beginning a Journey")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap1"
    }
  }, [_vm._v("1: My Master")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/Chap2"
    }
  }, [_vm._v("2: A Better Freedom")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3: One Word, Three Worlds")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PartTwo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two: Becoming Slaves of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4: I, Paul, a Slave of Christ")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5: My Son, Onesimus")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6: Eye-Slaves and People-Pleasers")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7: Your Father’s Name")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8: Don’t Worry About It")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9: Freed From and Freed To")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/PartThree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three: Encountering Christ the Slave")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10: Christ the Slave")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11: Slaves Who Waited for the Way")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12: Parables of Slavery")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13: The Servant Savior")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14: The Death of a Slave")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15: Breakfast with a Wounded Slave")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Chap16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16: Capture Me, for I Am Fleeing")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Epilogue",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: "), _c('em', [_vm._v("Freedom")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Coda",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coda by Sara Groves")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixA",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix A: "), _c('em', [_vm._v("A Comparison of the Three Worlds of Slavery")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixB",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix B: "), _c('em', [_vm._v("A Lexicon of Slavery")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixC",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix C: "), _c('em', [_vm._v("A List of Possible Slaves in the New Testament")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixD",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix D: "), _c('em', [_vm._v("The Slave Parables")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/AppendixE",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendix E: "), _c('em', [_vm._v("The Facts of Modern Slavery")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography ")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstverse"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/MoreTitlesfromIVP",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0